// extracted by mini-css-extract-plugin
export default {"emptyCartContainer":"CartBody_emptyCartContainer__WHDnP","text":"CartBody_text__FzWMl"};